/**
 *
 * ProfileTeam
 *
 */

import React from "react"
import { List, Avatar, Divider } from "antd"
import { withRouter } from "react-router-dom"
import { ROLE_AMBASSADOR, ROLE_LEADER } from "utils/constants"
import "./index.less"

function UserList(props) {
  const {
    list,
    history,
    className,
    title,
    hideLine,
    titleType,
    listProps,
    styleContainer,
  } = props

  return (
    <div className="UserList-Component" style={styleContainer}>
      <div
        style={{ position: "relative" }}
        className={`UserList-Component-title-${titleType}`}>
        <h3>{title}</h3>
        <Divider style={hideLine ? { background: "transparent" } : {}} />
      </div>

      <List
        className={className || ""}
        dataSource={list}
        renderItem={(item) => (
          <List.Item
            key={item.id}
            className={item.date_birth_2 ? "birthday-team" : ""}
            onClick={() => {
              if (item.is_user) {
                if (item.is_ambassador) {
                  history.push(`/ambassador/${item.id_ambassador}`)
                } else {
                  history.push(`/leader/${item.id_employee}`)
                }
              }
            }}
            style={{
              cursor: item.is_user ? "pointer" : null,
              borderBottom: !listProps.bottomLine ? "0" : "",
            }}>
            <List.Item.Meta
              avatar={
                <Avatar
                  src={item.profile_picture || item.picture_profile}
                  size={50}
                />
              }
              title={`${item.first_name} ${item.last_name}`}
              description={item.position_name}
            />
          </List.Item>
        )}
      />
    </div>
  )
}

UserList.propTypes = {}
UserList.defaultProps = {
  titleType: "default", // can be 'alt'
  listProps: { bottomLine: true },
  styleContainer: {},
}

export default withRouter(UserList)
